import { compose } from 'redux';
import { setDisplayName, withProps } from 'recompose';
import RatingFormField from '../../../../rating/RatingFormField';
import styles from './MatrixRatingInput.scss';
import withScaleRatingIcons from '../../../../scaleQuestion/withScaleRatingIcons/withScaleRatingIcons';

export default compose(
  withProps(
    ({
      ratingItemClassName,
      block: { color, enableFillColor, type, itemList },
      shape,
      value,
      onChange,
      labelList,
      itemListCount,
      ratingIconList,
      sliderHandleIcon,
    }) => {
      return {
        shouldHidePersonalIndex: { mobile: false, desktop: true },
        shouldHandleError: false,
        segmentClassName: styles.segment,
        indexClassName: styles.onlyMobile,
        ratingItemClassName,
        ratingIconList,
        ratingClassName: styles.rating,
        segmentLabelList: labelList,
        sliderHandleIcon,
        itemListCount,
        input: { value, onChange },
        block: { color, enableFillColor, shape, type, itemList },
      };
    },
  ),
  setDisplayName('MatrixRatingInput'),
  withScaleRatingIcons,
)(RatingFormField);
